import React from 'react';
import ChatCopyButton from './ChatCopyButton';

/** The reader's own turn, right-aligned, with copy on hover. */
const ChatUserMessage: React.FC<{ content: string }> = ({ content }) => (
  <div className="group mb-4 flex justify-end">
    <div className="flex max-w-[90%] items-start gap-2">
      <ChatCopyButton content={content} className="mt-1.5" />

      <div className="max-w-full rounded-2xl bg-accent px-3.5 py-1.5">
        <p className="whitespace-pre-wrap break-words text-sm leading-normal">{content}</p>
      </div>
    </div>
  </div>
);

export default ChatUserMessage;
